import React, { useEffect, useRef, useState } from 'react'
import { Text, Image, View, FlatList, TouchableOpacity, Dimensions, Animated, StatusBar, PixelRatio } from 'react-native'
import { DataSheetModel, PerfectStoreMediaModel, PerfectStoreModel } from './models/StoreDetailModel'
import { StoreFormItemPS } from './StoreFormItem'
import { FormHorizontalTags } from './FormHorizontalTags'
import { ScrollView } from 'react-native'
import theme from '../../../theme'
import styles from './PerfectStoreViewStyles'
import { EvilIcons, Feather } from '@expo/vector-icons'
import { placeholderGeneral } from '../customUtils/Constants'
import { StackScreenProps } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { AdditionalView, BarCodeErrorView, BarcodeButton } from './ExecutionView'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import CameraView from '../customUtils/CameraView'
import { ImageWithZoom, ImageWithZoomStores, searchFile } from '../customUtils/Components/ImageWIthZoom'
import { ImageWithZoomContain } from '../customUtils/Components/ImageWithZoomContain'
import { FormAnswers } from './FormAnswers'
import { Easing } from 'react-native'
import { getImageSize, validateConnectionNetwork } from '../../utils/functions.utils'
import { Platform } from 'react-native'
import BottomSheetWrapper from '../BottomSheetWrapper';
let BottomSheet = Platform.OS !== 'web' ? BottomSheetWrapper : undefined;
let BottomSheetView = Platform.OS !== 'web' ? BottomSheetWrapper.BottomSheetView : undefined;

const deviceWidth = Dimensions.get('window').width

interface Props extends StackScreenProps<DotsNavigation, 'PerfectStoreView'> {}

export const PerfectStoreVIew = ({ route }: Props) => {
    const [currentIndex, setCurrentIndex] = useState(0)
    const { perfectStore, selectedIndex, storeInfo } = route.params
    const [selectedPerfectStore, setPF] = useState<PerfectStoreModel>()
    const [selectedMedia, setMedia] = useState<PerfectStoreMediaModel[]>([])
    const [store, setStoreInfo] = useState<DataSheetModel>()
    const [type, setPFType] = useState(0)
    const { languageFile } = getLanguage()
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const mediasRef = useRef(selectedMedia)
    const [firstLoad, setFirstLoad] = useState(true)
    const allFilter = { _id: '-1', name: 'TODOS', isSelected: true }
    const allTags = [allFilter, ...(selectedPerfectStore?.tags ?? [])]
    const [animation] = useState(new Animated.Value(0))

    // console.log('selectedPerfectStore', allTags)
    useEffect(() => {
        onClickPerfectStore(selectedIndex)
    }, [perfectStore])

    useEffect(() => {
        setStoreInfo(dataStore)
    }, [])
    useEffect(() => {
        if (selectedMedia.length > 0) {
            mediasRef.current = selectedMedia
            setHeigth(mediasRef.current, selectedIndex)
        }
    }, [selectedMedia])

    const onClickPerfectStore = (index: number) => {
        if (selectedPerfectStore != perfectStore[index]) {
            let type = 0
            if (perfectStore[index].forms_answers) {
                type = -1
            } else {
                type = perfectStore[index].type?.type ?? 0
            }
            setPFType(type)
            setMedia(perfectStore[index].medias ?? [])
            setCurrentIndex(0)
            console.log('TYPE', type)
            mediasRef.current = perfectStore[index].medias ?? []

            setPF(perfectStore[index])
            setHeigth(mediasRef.current, 0)
            scrollX.setValue(0)
        }
        setFirstLoad(false)
    }

    const onClickTag = (id: string) => {
        mediasRef.current = []
        setMedia([])
        if (id === '-1') {
            setMedia(selectedPerfectStore.medias)
            mediasRef.current = selectedPerfectStore.medias
        } else {
            setMedia(selectedPerfectStore.medias.filter((media) => String(media.tag?._id) == id))
            mediasRef.current = selectedPerfectStore.medias.filter((media) => String(media.tag?._id) == id)
        }
    }

    const returnBarCode = async (code: string) => {
        try {
            console.log('Codigo leido', code)
            let codes = selectedPerfectStore.medias?.map((item) => item.description) ?? []
            console.log('Codigos', codes)
            const foundItem = selectedPerfectStore.medias?.find((item) => item.description === code)
            console.log('Item encontrado', foundItem)
            if (foundItem) {
                return openSheet(foundItem)
            } else {
                openBottomSheet(
                    <BarCodeErrorView
                        onPressRetry={() => {
                            closeBottomSheet(true)
                            canShowCamera()
                        }}
                    />,
                    ['45%'],
                )
            }
        } catch (error) {
            console.error('Error en returnBarCode:', error)
        }
    }

    const canShowCamera = async () => {
        let title = languageFile.search_by_barcode
        let desc = languageFile.scan_the_barcode
        if (Platform.OS === 'web') {
            openBottomSheet(
                <View style={{ padding: 24, alignItems: 'center' }}>
                    <Text style={{ fontSize: 18, color: 'red' }}>Funcionalidad no disponible en web</Text>
                </View>
            )
        } else {
            openBottomSheet(
                <>
                    <CameraView
                        closeBottomSheet={closeBottomSheet}
                        returnedValue={(code: string) => returnBarCode(code)}
                        title={title}
                        description={desc}
                        barcode={true}
                        closeCameraModal={() => closeBottomSheet()}
                    />
                    <TouchableOpacity style={styles.containerFloatingButton} onPress={() => closeBottomSheet()}>
                        <Text style={styles.floatingButtonText}>{languageFile.return_to_form}</Text>
                        <View style={styles.horizontalLine}></View>
                    </TouchableOpacity>
                </>
            )
        }
        //  returnBarCode('7791337007260') => DASA
    }

    const scrollX = useRef(new Animated.Value(0)).current

    const onScroll = Animated.event([{ nativeEvent: { contentOffset: { x: scrollX } } }], { useNativeDriver: false })

    useEffect(() => {
        const listener = scrollX.addListener(({ value }) => {
            const index = Math.round(value / deviceWidth)
            setCurrentIndex(index)
            setHeigth(mediasRef.current, index)
        })

        return () => {
            scrollX.removeAllListeners()
            scrollX.removeListener(listener)
            // listener.remove()
        }
    }, [scrollX, deviceWidth])

    const openSheet = (item) => {
        openBottomSheet(<PSPriceSheet item={item} onClose={closeBottomSheet} />)
    }

    const setHeigth = async (selectedMedia, index) => {
        let currentImage = selectedMedia[index]?.media_url || null

        if (currentImage && currentImage != null) {
            let image = await searchFile(currentImage, 'assets')

            if (image.includes('http')) {
                Image.getSize(currentImage, (width, height) => {
                    const ratio = height / width
                    const calculatedHeight = deviceWidth * ratio
                    setCurrentHeight(calculatedHeight)
                })
            } else {
                const { height, width } = await getImageSize(image)

                if (height && width) {
                    const ratio = height / width
                    const calculatedHeight = deviceWidth * ratio
                    setCurrentHeight(calculatedHeight)
                } else {
                    setCurrentHeight(deviceWidth)
                }
            }
        } else {
            setCurrentHeight(deviceWidth)
        }
    }

    const [currentHeight, setCurrentHeight] = useState(deviceWidth)

    // Efecto para actualizar la animación cuando cambia currentIndex
    useEffect(() => {
        Animated.timing(animation, {
            toValue: currentIndex,
            duration: 300, // Duración de la animación
            easing: Easing.ease, // Easing para suavizar la animación
            useNativeDriver: false, // No usamos Native Driver porque animamos el estilo en el contenedor
        }).start()
    }, [currentIndex])

    // Calcular los índices de los bullets a mostrar, manteniendo el bullet actual en el centro
    const startIndex = Math.max(0, currentIndex - 3) // Empieza a mostrar desde 3 antes del currentIndex
    const endIndex = Math.min(mediasRef.current?.length - 1, startIndex + 5) // Muestra hasta 6 elementos máximo

    // Crear un rango de índices para los bullets visibles
    const visibleBullets = mediasRef.current?.slice(startIndex, endIndex + 1)

    // Asegurarse de que currentIndex esté en el rango visible
    const currentIndexInVisibleBullets = currentIndex - startIndex

    const [iconSize, setIconSize] = useState(20)
    const fontScale = 1
    // Detectar si el tamaño de la fuente ha sido aumentado
    useEffect(() => {
        if (fontScale > 1) {
            setIconSize(24) // Cambiar iconSize si el tamaño de la fuente es más grande
        } else {
            setIconSize(20) // Valor normal
        }
    }, [])

    return (
        <>
            {storeInfo && (
                <>
                    <View style={styles.containerInfoStore}>
                        <View style={styles.containerNameStore}>
                            <Image
                                style={[styles.storeImage, { width: iconSize, height: iconSize, tintColor: theme.colors.textPrimary }]}
                                source={require('../../../assets/stores/store.png')}
                            />
                            <Text style={[styles.textNameStore, { color: theme.colors.textPrimary }]}>{storeInfo.name}</Text>
                        </View>
                        {storeInfo.address && storeInfo.address != '-' && <Text style={styles.textAddressStore}>{storeInfo.address}</Text>}
                        <View style={styles.containerNameStore}>
                            {storeInfo.code && <Text style={styles.storecode}>{storeInfo.code} </Text>}

                            {storeInfo.additional && <AdditionalView additional={storeInfo.additional} />}

                            <View style={styles.containerRow}>
                                {storeInfo.cluster && <Text style={styles.textInfoStore}>| {storeInfo.cluster}</Text>}
                                {storeInfo.distance && storeInfo.cluster && storeInfo.cluster.length < 15 && fontScale <= 1 && (
                                    <View style={styles.containerRow}>
                                        <Text style={styles.textInfoStore}> | </Text>
                                        <Feather style={styles.marginRight} name='map-pin' size={iconSize} color={theme.colors.textSecondary} />
                                        <Text style={styles.textInfoStore}>{storeInfo.distance}</Text>
                                    </View>
                                )}
                            </View>
                        </View>
                        {(storeInfo.distance && storeInfo.cluster && storeInfo.cluster.length >= 15) ||
                            (fontScale > 1 && (
                                <View style={[styles.flexDirectionRow, styles.marginHorizontal]}>
                                    <Feather style={styles.marginRight} name='map-pin' size={iconSize} color={theme.colors.textSecondary} />
                                    <Text style={styles.textInfoStore}>{storeInfo.distance}</Text>
                                </View>
                            ))}
                    </View>
                </>
            )}

            <View style={styles.container}>
                <View style={styles.spacer1}></View>
                <View style={styles.containerFilters}>
                    {perfectStore && perfectStore?.length > 1 && (
                        <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} style={styles.scrollView}>
                            <View style={[styles.flexDirectionRow, styles.marginHorizontalSix]}>
                                {perfectStore.map((pf, index) => {
                                    const isSelected = selectedPerfectStore === pf

                                    return (
                                        <StoreFormItemPS
                                            key={index}
                                            name={pf?.title}
                                            image={pf?.icon}
                                            index={index}
                                            onClickItem={onClickPerfectStore}
                                            isSelected={isSelected}
                                        />
                                    )
                                })}
                            </View>
                        </ScrollView>
                    )}
                </View>

                {selectedPerfectStore?.tags?.length > 0 && (
                    <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} style={[styles.containerTags, { minHeight: 35 }]}>
                        <View style={[styles.flexDirectionRow, styles.marginHorizontalSix, styles.marginTop]}>
                            <FormHorizontalTags tags={allTags} onClickTag={onClickTag} />
                            <View style={styles.spacer}></View>
                        </View>
                    </ScrollView>
                )}

                {selectedPerfectStore && selectedPerfectStore.show_barcode && <BarcodeButton canShowCamera={canShowCamera} />}
                {/* <Text>{selectedPerfectStore.type?.type ?? 'Nada'}</Text> */}
                {(() => {
                    switch (type) {
                        case -1:
                            return (
                                <>
                                    {selectedPerfectStore.forms_answers && selectedPerfectStore.forms_answers.length > 0 && (
                                        <FormAnswers answers={selectedPerfectStore.forms_answers[0].answers} />
                                    )}
                                </>
                            )
                        case 2:
                            return (
                                <View style={styles.marginTop}>
                                    {mediasRef.current?.length > 0 && (
                                        <View key={selectedPerfectStore?._id}>
                                            <ScrollView style={styles.scrollViewBis}>
                                                <>
                                                    {mediasRef.current &&
                                                        mediasRef.current[currentIndex] &&
                                                        mediasRef.current[currentIndex].title && (
                                                            <Text style={styles.titleTextPG}>{mediasRef.current[currentIndex].title}</Text>
                                                        )}
                                                    {selectedMedia && selectedMedia[currentIndex] && selectedMedia[currentIndex].description && (
                                                        <Text style={styles.descriptionTextPG}>{mediasRef.current[currentIndex].description}</Text>
                                                    )}
                                                    {mediasRef.current?.length > 1 && (
                                                        <View style={styles.floatPageIndicator}>
                                                            <Text style={styles.floatPageIndicatorText}>
                                                                {currentIndex + 1}/{mediasRef.current.length}
                                                            </Text>
                                                        </View>
                                                    )}
                                                    <Animated.FlatList
                                                        style={{ width: deviceWidth, height: currentHeight + 50 }}
                                                        horizontal={true}
                                                        showsHorizontalScrollIndicator={false}
                                                        pagingEnabled
                                                        onScroll={onScroll}
                                                        data={mediasRef.current}
                                                        keyExtractor={(item, index) => item.media_url.toString()}
                                                        renderItem={({ item: media, index }) => (
                                                            <View>
                                                                <ImageWithZoomContain uri={media.media_url} path={'assets'} />
                                                            </View>
                                                        )}
                                                        viewabilityConfig={{ viewAreaCoveragePercentThreshold: 50 }}
                                                    />
                                                    {mediasRef.current?.length > 1 && (
                                                        <View style={styles.bulletsContainer}>
                                                            <View style={styles.bulletsIndicator}>
                                                                {visibleBullets.map((_, index) => {
                                                                    // Calculamos la interpolación para cada bullet en función de la animación
                                                                    const scale = animation.interpolate({
                                                                        inputRange: [index - 1, index, index + 1], // Transiciones entre el bullet anterior, el actual y el siguiente
                                                                        outputRange: [0.8, 1, 0.8], // Cambio de tamaño
                                                                        extrapolate: 'clamp', // Limita la interpolación a este rango
                                                                    })

                                                                    const opacity = animation.interpolate({
                                                                        inputRange: [index - 1, index, index + 1],
                                                                        outputRange: [0.4, 1, 0.4],
                                                                        extrapolate: 'clamp', // Limita el valor
                                                                    })

                                                                    return (
                                                                        <Animated.View
                                                                            key={index}
                                                                            style={[
                                                                                styles.circleBulletIndicator,
                                                                                {
                                                                                    opacity,
                                                                                    transform: [{ scale }],
                                                                                },
                                                                                index === currentIndexInVisibleBullets
                                                                                    ? styles.currentBulletIndicator
                                                                                    : null, // Aplicar el estilo solo cuando sea el bullet activo
                                                                            ]}
                                                                        />
                                                                    )
                                                                })}
                                                            </View>
                                                        </View>
                                                    )}
                                                </>
                                                <View style={{ height: 108 }}></View>
                                            </ScrollView>
                                        </View>
                                    )}
                                </View>
                            )
                        case 17:
                            return (
                                mediasRef.current?.length > 0 && (
                                    <FlatList
                                        data={mediasRef.current}
                                        horizontal={false}
                                        keyExtractor={(item) => item._id}
                                        showsVerticalScrollIndicator={false}
                                        renderItem={({ item: item }) => <PriceItem item={item} onClick={() => openSheet(item)} />}
                                        numColumns={1}
                                    />
                                )
                            )

                        default:
                            return (
                                <>
                                    <View style={styles.containerNoMessage}>
                                        <Image style={styles.imageNoMessage} source={require('../../../assets/noFormSelected.png')} />
                                        <Text style={styles.titleNoMessage}>{languageFile.select_form}</Text>
                                        <Text style={styles.descriptionNoMessage}>{languageFile.select_one_form}</Text>
                                    </View>
                                </>
                            )
                    }
                })()}
            </View>
        </>
    )
}

export const PSPriceSheet = ({ item, onClose }: { item: PerfectStoreMediaModel; onClose: () => void }) => {
    return (
        <ScrollView style={styles.containerPS}>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            <View style={styles.container}>
                <View style={styles.alignCenter}>
                    {item.title && <Text style={styles.titleBis}>{item.title}</Text>}
                    {item.description_long && <Text style={styles.productBis}>{item.description_long ?? ''}</Text>}
                    {item.description && <Text style={styles.descriptionBis}>{item.description}</Text>}
                    {item.media_url && <ImageWithZoomStores uri={item.media_url ? item.media_url : placeholderGeneral} />}

                    {item.description_short && <Text style={styles.priceBis}>{item.description_short}</Text>}
                </View>
            </View>
            <View style={styles.spacerBis}></View>
            {/*<TouchableOpacity style={[styles.borderButton, { marginTop: 12, marginBottom: 24 }]} onPress={() => onClose()}>
                <Text style={styles.borderButtonText}>Confirmar</Text>
                </TouchableOpacity>*/}
        </ScrollView>
    )
}
export const PriceItem = ({ item, onClick }: { item: PerfectStoreMediaModel; onClick: () => void }) => {
    const [image, setImage] = useState(null)
    const { openBottomSheet } = useBottomSheet()
    const path = 'assets'
    const placeHolder = require('../../../assets/placeholderImage.png')

    const openBigImage = () => {
        if (item?.media_url && image) {
            openBottomSheet(<ImageWithZoom uri={image} contentSeen={() => {}} path={path} />, undefined, undefined, true, true, true)
        }
    }
    // console.log('ITEM', item.media_url)

    const getImageItem = async () => {
        const uri = item.media_url
        let image = await searchFile(uri, path)
        if (image) {
            setImage({ uri: image })
        } else {
            const hasConnection = await validateConnectionNetwork()
            if (hasConnection) {
                setImage({ uri: item.media_url })
            } else {
                setImage(placeHolder)
            }
        }
    }

    useEffect(() => {
        getImageItem()
    }, [item])

    return (
        <View>
            <View style={styles.containerPriceItem}>
                <View style={styles.container}>
                    {item?.media_url && (
                        <TouchableOpacity style={styles.imageProduct} onPress={() => openBigImage()}>
                            <Image style={styles.imageProduct} source={image} resizeMode='contain' />
                        </TouchableOpacity>
                    )}
                </View>

                <View style={styles.containerInfoProduct}>
                    {item.description_long && <Text style={styles.product}>{item.description_long ?? ''}</Text>}
                    {item.description && <Text style={styles.ean}>{item.description ?? ''}</Text>}
                    {item.sku && <Text style={styles.sku}>{item.sku ?? ''}</Text>}
                </View>
                <View>{item.description_short && <Text style={styles.price}>{item.description_short ?? ''}</Text>}</View>
            </View>
            <View style={styles.dividerHorizontalLine}></View>
        </View>
    )
}

export const dataStore = {
    _id: '5f9b1b3b7f7b1b001f3b1b3b',
    fields: [],
    history_check_in: [],
    lat: '10.776676',
    lng: '106.700367',
    code: 'HCM-0001',
    name: 'Cửa hàng 1',
    address: 'Horacio Salvador 405',
    name_cluster: 'Cluster 007XC',
}
